import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaBars, FaTimes, FaUserPlus, FaSignOutAlt } from "react-icons/fa";
import "../styling/Navbar.css";
import ShowTime from "./LiveDateTime";
import { useAuth } from "../context/AuthContext";
import { useTheme } from "../context/ThemeContext";

const Navbar = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const { user, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();

  const handleLogout = () => {
    logout();
    window.location.reload();
    setMenuOpen(false);
    navigate("/login", { replace: true });
  };

  return (
    <header className="navbar">
      <div className="nav-container">
        <div className="nav-logo" onClick={() => navigate("/loanlist")}>
          ✦ MyLoanApp
        </div>

        <div className="nav-time">
          <ShowTime />
        </div>

        <div className={`nav-links ${menuOpen ? "open" : ""}`}>
          {user ? (
            <>
              <span className="nav-user">👤 {user.name}</span>

              {user.role === "admin" && (
                <Link
                  to="/register"
                  className="nav-btn secondary"
                  onClick={() => setMenuOpen(false)}
                >
                  <FaUserPlus /> Register User
                </Link>
              )}

              <button className="nav-btn danger" onClick={handleLogout}>
                <FaSignOutAlt /> Logout
              </button>
            </>
          ) : null}

          {/* Theme toggle — always visible */}
          <button
            className="theme-toggle"
            onClick={toggleTheme}
            title={theme === "dark" ? "Switch to Light Mode" : "Switch to Dark Mode"}
            aria-label="Toggle theme"
          >
            {theme === "dark" ? "☀️" : "🌙"}
          </button>
        </div>

        <div className="nav-right-mobile">
          <button
            className="theme-toggle"
            onClick={toggleTheme}
            title="Toggle theme"
            aria-label="Toggle theme"
          >
            {theme === "dark" ? "☀️" : "🌙"}
          </button>
          <button
            className="menu-toggle"
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
